import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { memberMobx } from '@mobxStore'
import { payPlanMobx } from '@mobx/mall/payment'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { KeyBoard, SwitchCardModal } from '@cps'
import './index.scss'

interface IProps {
  card: IMemberCardInfo;
  resolve?: (amount: number) => void;
  reject?: () => void;
  firstNum?: number;

}

const MemberCardAmountModal: FC<IProps> = ({ card, firstNum, resolve, reject }) => {
  const initailNum: number = card.balance > Number(firstNum) ? firstNum : card.balance
  const [amountStr, setAmountStr] = useState<string>(initailNum.toFixed(2))
  const [amount, setAmount] = useState<number>(0)

  useEffect(() => {
    try {
      const amount = parseFloat(amountStr)
      setAmount(amount)
      if (amount > card.balance) {
        setAmountStr(card.balance.toFixed(2))
      }
      if (card.card.isPayTip) {
        if (amount > payPlanMobx.totalAmount) {
          setAmountStr(payPlanMobx.totalAmount.toFixed(2))
        }
        const nonTipAmount = payPlanMobx.totalAmount - payPlanMobx.tipAmount
        if (amount > nonTipAmount + card.balanceRecharge) {
          setAmountStr((nonTipAmount + card.balanceRecharge).toFixed(2))
        }
      } else {
        const nonTipAmount = payPlanMobx.totalAmount - payPlanMobx.tipAmount
        if (amount > nonTipAmount) {
          setAmountStr(nonTipAmount.toFixed(2))
        }
      }
    } catch { }
  }, [amountStr])

  const changeCard = async () => {
    await modalLayer(SwitchCardModal, { type: 'mall', isPay: true }, 'switchCardModal')
    reject()
  }

  const canSubmit = amount >= 0

  const submit = () => {
    resolve && resolve(amount)
  }

  return (
    <IonModal
      isOpen
      cssClass='mall-member-card-amount-modal height620-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='member-card-amount-header'>
          <i className='iconfont icon-huiyuanjia2x' />
          <div className='card-info'>
            <div className='card-name'>
              {card.card.cardName || i18n.t('pay.memberCard')}
              {/* {!card.card.isPayTip ? (
                <CannotPayTip message={i18n.t('pay.memberCardCannotPayTip')} />
              ) : (
                <CannotPayTip message={i18n.t('pay.memberCardGiveBalanceCannotPayTip')} />
              )} */}
            </div>
            <div className='balance'>{i18n.t('pay.cardBalanceN', { n: format.toPrice(card.balance) })}</div>
          </div>
          {
            memberMobx.cardListForMall.length > 1 ? (
              <div className='change-card '>
                <i className=' iconfont icon-arrows--horizontal' onClick={changeCard}></i>
              </div>
            ) : ''
          }
        </div>
      </IonHeader>
      <IonContent>
        <div className='amount'>{amountStr}</div>
        <div className='hint'>{i18n.t('pay.payThisTime')}</div>
        <KeyBoard value={amountStr} onChange={setAmountStr} />
      </IonContent>
      <IonFooter className='member-card-amount-footer'>
        <button className='cancel-button' onClick={reject}>{i18n.t('common.cancel')}</button>
        <button className='submit-button' disabled={!canSubmit} onClick={submit}>{i18n.t('common.ok')}</button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(MemberCardAmountModal)
